import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, alpha, useTheme } from '@mui/material';
import { JournalLineView } from '../../../types/finance';
import Amount from './Amount';
import AccountLedgerLink from './AccountLedgerLink';

/** The debit/credit lines of an entry or journal, with their totals. */
const JournalLinesTable: React.FC<{ lines: JournalLineView[] }> = ({ lines }) => {
  const theme = useTheme();
  const debit = lines.reduce((s, l) => s + l.debitPaisa, 0);
  const credit = lines.reduce((s, l) => s + l.creditPaisa, 0);
  return (
    <Table size="small" sx={{ '& td, & th': { px: 1.5 } }}>
      <TableHead>
        <TableRow sx={{ bgcolor: alpha(theme.palette.text.primary, 0.02) }}>
          <TableCell>Account</TableCell>
          <TableCell sx={{ width: 120 }} align="right">Debit</TableCell>
          <TableCell sx={{ width: 120 }} align="right">Credit</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {lines.map((l, i) => (
          <TableRow key={l._id ?? i}>
            <TableCell sx={{ pl: l.creditPaisa > 0 ? 4 : 1.5 }}>
              <AccountLedgerLink accountId={l.accountId} code={l.accountCode} name={l.accountName} />
              {l.description && (
                <Typography variant="caption" color="text.secondary" display="block">{l.description}</Typography>
              )}
            </TableCell>
            <TableCell align="right"><Amount paisa={l.debitPaisa} /></TableCell>
            <TableCell align="right"><Amount paisa={l.creditPaisa} /></TableCell>
          </TableRow>
        ))}
        <TableRow sx={{ '& td': { borderBottom: 0, fontWeight: 700 } }}>
          <TableCell>Total</TableCell>
          <TableCell align="right"><Amount paisa={debit} fontWeight={700} /></TableCell>
          <TableCell align="right"><Amount paisa={credit} fontWeight={700} /></TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default JournalLinesTable;
